export default {
    "title": "🇪🇸 Español",

    "首页": "Inicio",
    "关于": "Acerca de",
    "会员": "Miembro",
    "推荐计划": "Plan de Referidos",
    "个人": "Personal",
    "推荐": "Recomendado",
    "预订": "Buscar Ahora",
    "事件": "Eventos",
    "登出": "Cerrar Sesión",
    "登录": "Iniciar Sesión",
    "注册": "Registrarse",
    "我们的应用程序现在可用": "Nuestra aplicación ya está disponible",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "Para una mejor experiencia, acabamos de lanzar la aplicación móvil para reservas sin problemas y más rápidas.",
    "iOS版下载（即将推出）": "Descargar para iOS (Próximamente)",
    "Android版下载（即将推出）": "Descargar para Android (Próximamente)",
    "为什么选择我们": "¿Por qué elegirnos?",
    "我们卓越的服务。": "Nuestro servicio excepcional.",
    "收入最高的酒店": "Propiedades Más Populares",
    "我们的合作酒店收入最高。": "Nuestras colaboraciones incluyen los proyectos inmobiliarios más rentables.",
    "回报": "Retorno",
    "最具特色的酒店": "Propiedades Únicas",
    "我们平台上最有特色的酒店。": "Las propiedades más únicas en nuestra plataforma.",
    "热门国家和目的地": "¡Explora las ubicaciones de inversión inmobiliaria más populares del Reino Unido con los mejores intermediarios inmobiliarios!",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "¡Analiza y promociona las propiedades más rentables con nosotros!",
    "酒店": "Hoteles",
    "预订酒店并开始赚取": "¡Explora el mercado inmobiliario con nosotros!",
    "让我们开始与TitanTraveler一起探索世界": "¡Analiza y promociona las propiedades más rentables con nosotros!",
    "客户评价": "Reseñas de Clientes",
    "查看我们用户的真实评价。": "Mira las reseñas reales de nuestros usuarios.",
    "银行卡列表": "Lista de Tarjetas Bancarias",
    "银行列表": "Lista de Bancos",
    "持卡人姓名": "Nombre del Titular",
    "银行卡号": "Número de Tarjeta",
    "支付密码": "Contraseña de Pago",
    "提交": "Enviar",
    "Pix列表": "Lista de Pix",
    "Pix类型": "Tipo de Pix",
    "Pix账号": "Cuenta Pix",
    "账号列表": "Lista de Cuentas",
    "网络": "Red",
    "地址": "Dirección",
    "备注": "Nota",
    "充值金额": "Monto de Recarga",
    "支付类型": "Tipo de Pago",
    "支付银行": "Banco de Pago",
    "USDT地址": "Dirección USDT",
    "二维码": "Código QR",
    "充值渠道": "Canal de Recarga",
    "充值凭证": "Comprobante de Recarga",
    "立即登录": "Iniciar Sesión Ahora",
    "用户名": "Nombre de Usuario",
    "密码": "Contraseña",
    "邀请码": "Código de Invitación",
    "确认密码": "Confirmar Contraseña",
    "手机": "Teléfono",
    "注册2": "Registrarse",
    "金额": "Monto",
    "新增": "Agregar",
    "我们的精彩": "Nuestra",
    "故事": "Historia",
    "奖项": "Premios",
    "获得": "Ganados",
    "钱包余额": "Saldo de Billetera",
    "今日奖励": "Recompensa de Hoy",
    "总行程": "Propiedades Totales",
    "访问行程": "Propiedades Visitadas",
    "酒店历史": "Historial de Propiedades",
    "单价": "Precio Unitario",
    "数量": "Cantidad",
    "总额": "Total",
    "奖励": "Recompensa",
    "上一页": "Anterior",
    "下一页": "Siguiente",
    "每套预订量": "Reservas por Propiedad",
    "预订奖励": "Recompensa de Reserva",
    "每日预订": "Reservas Diarias",
    "手机号码": "Número de Teléfono",
    "修改密码": "Cambiar Contraseña",
    "登录密码": "Contraseña de Inicio de Sesión",
    "当前密码": "Contraseña Actual",
    "新密码": "Nueva Contraseña",
    "确认新密码": "Confirmar Nueva Contraseña",
    "保存修改": "Guardar Cambios",
    "充值": "Recargar",
    "我们的": "Nuestro",
    "复制": "Copiar",
    "分享链接": "Compartir Enlace",
    "搜索酒店": "Buscar Propiedades",
    "实际等级": "Nivel Real",
    "升级": "Actualizar",
    "已完成预订": "Propiedades Totales",
    "登录时间": "Tiempo de Inicio de Sesión",
    "信誉分": "Puntuación de Crédito",
    "控制菜单": "Menú de Control",
    "提现": "Retirar",
    "提现账号": "Cuenta de Retiro",
    "你确定要删除此账号吗": "¿Estás seguro de que quieres eliminar esta cuenta?",
    "你确定要删除此地址吗": "¿Estás seguro de que quieres eliminar esta dirección?",
    "提示": "Aviso",
    "是": "Sí",
    "否": "No",
    "全部": "Todo",
    "待处理": "Pendiente",
    "冻结中": "Congelado",
    "已完成": "Completado",
    "订阅": "Suscribirse",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Desea recibir notificaciones cuando lancemos nuevas plantillas o actualizaciones. Simplemente regístrese y le enviaremos notificaciones por correo electrónico.",
    "我们的伙伴": "Nuestros Socios",
    "关于我们": "Acerca de Nosotros",
    "实时聊天支持": "Soporte de Chat en Tiempo Real",
    "在线聊天": "Chat en Línea",
    "创建时间": "Tiempo de Creación",
    "你确定要登出当前账号吗？": "¿Estás seguro de que quieres cerrar sesión de la cuenta actual?",
    "请输入你的邮箱": "Por favor ingresa tu correo electrónico",
    "好评": "Excelente",
    "条评论": "comentarios",
    "平均每晚": "Promedio por Noche",
    "旅行旅程": "Detalles de Propiedad",
    "正在寻找酒店": "Buscando Hoteles",
    "开始预订": "Comenzar",
    "旅程价格": "Precio del Viaje",
    "佣金": "Comisión",
    "底部-about": "Somos WOLO, una agencia inmobiliaria con sede en España, enfocada en impulsar el desarrollo del sector inmobiliario a través de estrategias innovadoras y basadas en datos. Nuestro enfoque se centra en el crecimiento y los resultados, ofreciendo servicios personalizados que se adaptan a las últimas tendencias del mercado inmobiliario español y europeo. Ya sea que su objetivo sea expandir rápidamente su empresa, o busque apoyo en diseño inmobiliario, gestión de propiedades, planificación estratégica o desarrollo de proyectos, WOLO cuenta con el conocimiento profesional y la experiencia necesaria para ayudarle a lograr los mejores resultados en este entorno altamente competitivo y orientado a resultados.",
    "立即预订": "Reservar Ahora",
    "搜索": "Buscar",
    "快乐的客户": "Clientes Felices",
    "快乐的酒店老板": "Propietarios Felices",
    "评论1": "Arquitectura en la arquitectura.",
    "评论2": "Es un buen lugar para pasear, con calles estrechas y algunos edificios hermosos.",
    "评论3": "Hermosa plaza ubicada entre la playa y la avenida central.",
    "评论4": "Edificio muy hermoso con una historia interesante.",
    "评论5": "Hay muchos restaurantes para elegir, con una atmósfera muy relajada.",
    "评论6": "Hermosa tierra con encantadores huertos de naranjas y animales.",
    "评论7": "Buen lugar para vacaciones de fin de semana.",
    "评论8": "Lugar interesante......",
    "评论9": "Un buen lugar para relajarse y observar el mundo girar.",
    "评论10": "Club de playa de alta gama, un hermoso homenaje a los caídos en la guerra.",
    "评论11": "¡Hay demasiado que ver, es un buen lugar para vacaciones y relajación!",
    "评论12": "Primera vez aquí, se sintió muy agradable, volveré la próxima vez.",
    "评论13": "¡Fue una experiencia diferente, se sintió bien, los locales fueron muy amigables y corteses!",
    "推荐计划1": "Los usuarios de la plataforma pueden invitar a otros a convertirse en agentes de la plataforma a través de códigos de referido, convirtiéndose en sus referidos.",
    "推荐计划2": "Como referente, puede obtener un cierto porcentaje de las ganancias de sus referidos. Las ganancias obtenidas por el referente se devolverán directamente a la cuenta de la plataforma del referente, o al informe del equipo.",
    "推荐计划3": "Nota: Todos los agentes/referidos de la plataforma recibirán correspondientemente un cierto porcentaje de ganancias y recompensas de la plataforma. Formar un equipo no afecta las ganancias y recompensas de ningún agente o referido.",
    "评分": "Calificación",
    "评论": "Comentarios",
    "酒店很棒": "El hotel es excelente",
    "终于体验了，酒店非常好": "Finalmente lo experimenté, el hotel es muy bueno",
    "我对酒店非常满意并推荐预订": "Estoy muy satisfecho con el hotel y recomiendo reservar",
    "我很高兴很满意，价格实惠": "Estoy muy feliz y satisfecho, el precio es asequible",
    "服务非常好，我非常喜欢": "El servicio es muy bueno, me gusta mucho",
    "体验很不错，朋友已经第二次预订了": "La experiencia es muy buena, mi amigo ya ha reservado por segunda vez",
    "酒店环境优美": "El entorno del hotel es hermoso",
    "酒店卫生干净": "El hotel está limpio y sanitario",
    "工作人员态度非常好": "La actitud del personal es muy buena",
    "酒店服务很棒": "El servicio del hotel es excelente",
    "你还没有设置支付密码，请前往设置": "Aún no has configurado la contraseña de pago, ve a configurar",
    "订单": "Pedido",
    "复制成功": "Copiado Exitosamente",
    "团队与条件": "Equipo y Condiciones",
    "站内信": "Mensaje Interno",
    "请联系客服升级会员": "Contacta al servicio al cliente para actualizar tu membresía",
    "我已阅读并同意": "He leído y acepto",
    "注册协议": "Acuerdo de Registro",
    "忘记密码": "Olvidé mi Contraseña",
    "账户明细": "Detalles de la Cuenta",
    "时间": "Tiempo",
    "类型": "Tipo",
    "代理支持": "Soporte de Agente",
    "冻结金额": "Monto Congelado",
} 